import { useSafeState } from 'ahooks';
import { message, Tooltip } from 'aui';
import classNames from 'clsx';
import copy from 'copy-to-clipboard';
import React from 'react';
import { MarkdownSafeMdxViewerLocaleContext } from '../../components/MarkdownSafeMdxViewer/MarkdownSafeMdxViewerLocaleContext';
import { formatMessageWithLocale } from '../../locales';
import styles from './index.module.less';

type IProps = {
  // 复制失败的提示语
  errorTooltip?: React.ReactNode;
  // 复制成功的提示语
  successTooltip?: React.ReactNode;
  // 待复制的提示语
  toolTip?: React.ReactNode;
  showToolTip?: boolean;
  disabled?: boolean;
  className?: string;
  getPopupContainer?: React.ComponentProps<typeof Tooltip>['getPopupContainer'];
} & (
  | {
      // 复制的String
      copyText?: string;
      // 默认显示文字，复制的文字
      text: React.ReactText;
    }
  | {
      // 复制的String
      copyText: string;
      // 默认显示文字，复制的文字
      text: React.ReactElement;
    }
);

const CopyableText: React.FC<IProps> = (props) => {
  const { text: textProp, disabled, className, showToolTip = true } = props;
  const locale = React.useContext(MarkdownSafeMdxViewerLocaleContext);

  const text = React.useMemo(() => {
    return typeof textProp === 'string' ? textProp.replace(/ /g, '\u00a0') : textProp;
  }, [textProp]);

  if (disabled) {
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    return <a>{text}</a>;
  }
  const baseTooltip = props.toolTip || formatMessageWithLocale(locale, { id: 'copyToClipboard' });

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [tooltip, setTooltip] = useSafeState(() => {
    return baseTooltip;
  });

  const handleCopy = (e: MouseEvent) => {
    e.stopPropagation();
    const copyText = (() => {
      if (props.copyText !== undefined) {
        return props.copyText || '';
      }
      return props.text.toString();
    })();
    const result = copy(copyText);
    let msg;
    if (result) {
      const successTooltip =
        props.successTooltip || formatMessageWithLocale(locale, { id: 'overView.isCopied' });
      msg = successTooltip;
      message.success(msg);
    } else {
      const errorTooltip =
        props.errorTooltip || formatMessageWithLocale(locale, { id: 'overView.failToCopied' });
      msg = errorTooltip;
      message.error(msg);
    }
    setTooltip(msg);
    setTimeout(() => {
      setTooltip(baseTooltip);
    }, 2000);
  };

  if (React.isValidElement(text) && showToolTip) {
    return (
      <Tooltip getPopupContainer={props.getPopupContainer} title={tooltip}>
        {React.cloneElement(text, {
          onClick: handleCopy,
        } as any)}
      </Tooltip>
    );
  }
  return (
    <>
      {showToolTip ? (
        <Tooltip getPopupContainer={props.getPopupContainer} title={tooltip}>
          <span className={classNames(styles.copyable, className)} onClick={handleCopy as any}>
            {text}
          </span>
        </Tooltip>
      ) : (
        <span className={classNames(styles.copyable, className)} onClick={handleCopy as any}>
          {text}
        </span>
      )}
    </>
  );
};
export default CopyableText;
